import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-male-chair-workouts': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-workouts&exp=web_chair_workouts_male_sales_tax_exclusion_i2~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_chair_workouts_male_sales_tax_exclusion_i2'
					),
			},
		},
	},
]

export default config
